import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from 'src/app/service/util.service';


@Component({
  selector: 'demo-trans-union',
  templateUrl: './demo-trans-union.html'
})
export class DemoTransUnion implements OnInit {
  preQualObj: any;
  isCoapplicantApplied: boolean;
  isExistingCustomer: boolean;
  areBothCibcCustomer: boolean;

  constructor(private utilService: UtilService, private router: Router, private _activatedRoute: ActivatedRoute) {
    this.utilService.isSidebarVisible.next(false);
  }

  ngOnInit(): void {
    console.log("initialized");
    this.preQualObj = this.utilService.getSessionStorage();
    this.isCoapplicantApplied = this.preQualObj.is_coapplicant_applied == 'Y' ? true : false;
    this.isExistingCustomer = this.preQualObj.is_existing_bankcustomers == 'Y' ? true : false;
    this.areBothCibcCustomer = this.preQualObj.are_both_applicants_CIBC_customer == 'Y' ? true : false;
  }
  tuResponse(status){
    if (status === 'failed'){
      this.router.navigate(['../request-callback'], {  relativeTo: this._activatedRoute, queryParamsHandling: 'preserve'});
    } else {
      this.router.navigate(['../income'], {  relativeTo: this._activatedRoute, queryParamsHandling: 'preserve'});
    }
  }

}


